import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { PGWTxnDashboardParam, TopPaymentChannelContainerModel, TopTenPaymentChannelRevenueContainerModel, TopTxnPercentageContainerModel, TxnBalanceCountContainerModel, TxnCountByStatusModel, TxnRevenueStatusContainerModel } from '../../models/pgw-transaction/pgw-transaction-dashboard.model';
import { getHttpHeader } from '../../utils/http-header.factory';
import { BaseService } from '../../templates/services/base-service.template';

@Injectable({
  providedIn: 'root'
})
export class PGWTransactionDashboardService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.UNIPIN_PREFIX + 'transaction-dashboard';

  constructor(protected readonly http: HttpClient) {}

  public getTxnTimeline(param: PGWTxnDashboardParam, { tenantCode, api_domain_url, jwt_secret }: ApiVisa):  Observable<ApiResponseModel<number[]>>{
    return this.http.get<ApiResponseModel<number[]>>(`${ api_domain_url }${ this.apiUrl }/timeline${ this.convertParam(param) }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getTopPaymentChannel(param: PGWTxnDashboardParam, { tenantCode, api_domain_url, jwt_secret }: ApiVisa):  Observable<ApiResponseModel<TopPaymentChannelContainerModel[]>>{
    return this.http.get<ApiResponseModel<TopPaymentChannelContainerModel[]>>(`${ api_domain_url }${ this.apiUrl }/piechart${ this.convertParam(param) }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getTopTxnPercentage(param: PGWTxnDashboardParam, { tenantCode, api_domain_url, jwt_secret }: ApiVisa):  Observable<ApiResponseModel<TopTxnPercentageContainerModel>>{
    return this.http.get<ApiResponseModel<TopTxnPercentageContainerModel>>(`${ api_domain_url }${ this.apiUrl }/halfbar-chart${ this.convertParam(param) }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getTopTenPaymentChannelRevenue(param: PGWTxnDashboardParam, { tenantCode, api_domain_url, jwt_secret }: ApiVisa):  Observable<ApiResponseModel<TopTenPaymentChannelRevenueContainerModel>>{
    return this.http.get<ApiResponseModel<TopTenPaymentChannelRevenueContainerModel>>(`${ api_domain_url }${ this.apiUrl }/top-ten-channel-revenue${ this.convertParam(param) }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getTxnBalanceCount(contractGuid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<TxnBalanceCountContainerModel>>{
    return this.http.get<ApiResponseModel<TxnBalanceCountContainerModel>>(`${ api_domain_url }${ Core2Config.TENANT_DOMAIN_URL_PREFIX }pgw/merchant-balance/backoffice-ep-balance/${ tenantCode }?merchantContractHdrGuid=${ contractGuid }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getTxnCountByStatus(param: PGWTxnDashboardParam, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<TxnCountByStatusModel>>{
    return this.http.get<ApiResponseModel<TxnCountByStatusModel>>(`${ api_domain_url }${ this.apiUrl }/count-per-status${ this.convertParam(param) }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public getTxnRevenueByStatus(param: PGWTxnDashboardParam, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<TxnRevenueStatusContainerModel>>{
    return this.http.get<ApiResponseModel<TxnRevenueStatusContainerModel>>(`${ api_domain_url }${ this.apiUrl }/revenue-per-status${ this.convertParam(param) }`, getHttpHeader(jwt_secret, tenantCode));
  }

  protected convertParam({ contract_guid, start_date, end_date }: PGWTxnDashboardParam): string{
    return `?contract_guid=${ contract_guid }&start_date=${ start_date }&end_date=${ end_date }`;
  }
}
